export default __webpack_public_path__ + "static/scale-ff398e3a98ebf25eac25247d5cfb0fdc.jpg";